import { useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'semantic-ui-react'
import env from '../../../env'
import { useSelector } from 'react-redux'

function BreadCrumb(props) {
  const navigate = useNavigate()

  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  return (
    <Breadcrumb>
      {props.breadcrumb?.map((breadcrumb, index) => {
        return (
          <span key={index}>
            <Breadcrumb.Section
              link
              style={{
                color: tenant?.deployment_primary_color,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate(breadcrumb.href)
              }}
            >
              {breadcrumb.name}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
          </span>
        )
      })}
      <Breadcrumb.Section
        active
        style={{
          color: tenant?.deployment_primary_color,
        }}
      >
        {props.header}
      </Breadcrumb.Section>
    </Breadcrumb>
  )
}

export default BreadCrumb
